import React from "react";
import { ShieldAlert, AlertTriangle, Info, ShieldCheck } from "lucide-react";
import { HomePanel, PanelEmpty } from "./HomePanel";
import { fmtDateHuman } from "@/portal/format";

function SeverityIcon({ severity }) {
  if (severity >= 6) return <span className="h-8 w-8 rounded-[6px] bg-cp-danger-soft text-cp-danger grid place-items-center shrink-0" aria-label="Risc ridicat"><AlertTriangle className="h-4 w-4" fill="currentColor" stroke="#fff" strokeWidth={1.6} /></span>;
  if (severity >= 3) return <span className="h-8 w-8 rounded-[6px] bg-cp-warning-soft text-cp-amber grid place-items-center shrink-0" aria-label="Risc mediu"><AlertTriangle className="h-4 w-4" fill="currentColor" stroke="#fff" strokeWidth={1.6} /></span>;
  return <span className="h-8 w-8 rounded-[6px] bg-cp-accent-soft text-cp-accent grid place-items-center shrink-0" aria-label="Risc scăzut"><Info className="h-4 w-4" fill="currentColor" stroke="#fff" strokeWidth={1.6} /></span>;
}

/** „Riscuri / Alerte” — riscurile active (deschise / monitorizate), ordonate după severitate. */
export function RisksCard({ risks, project }) {
  const list = (risks || []).slice(0, 3);
  const pid = list[0]?.project_id || project?.id;
  return (
    <HomePanel icon={ShieldAlert} title="Riscuri / Alerte" to={pid ? `/portal/proiecte/${pid}?tab=risc` : undefined} testid="home-risks">
      {list.length === 0 ? <PanelEmpty icon={ShieldCheck} tone="success" text="Niciun risc activ raportat. Echipa monitorizează permanent proiectul." /> : (
        <ul className="space-y-3.5 mt-0.5" data-testid="home-risks-list">
          {list.map((r) => (
            <li key={r.id} className="flex items-start gap-3" data-testid={`home-risk-${r.id}`}>
              <SeverityIcon severity={r.severity} />
              <div className="flex-1 min-w-0">
                <div className="text-[13.5px] font-semibold text-cp-text leading-snug">{r.title}</div>
                {(r.description || r.mitigation) && <p className="text-[12.5px] text-cp-text-2 leading-snug mt-0.5 line-clamp-2">{r.description || r.mitigation}</p>}
              </div>
              <span className="cp-meta whitespace-nowrap shrink-0 pt-0.5">{fmtDateHuman(r.updated_at || r.created_at)}</span>
            </li>
          ))}
        </ul>
      )}
    </HomePanel>
  );
}
